// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StringListWidget_wrapper__T-6Lb","toolbar":"StringListWidget_toolbar__14ePV"};